module.exports = __webpack_public_path__ + "media/2-11.df032774.wav";